import { BookService, ObserverService, ListingModalService } from '@DavisDigital/davisdigitalfrontend.module';
import { Modal, PageImage } from "@DavisDigital/interfaces";

class BookPageAssetsController {
	
	private bookID: string;
	
	public pageImages;
	public pageVideos;
	public isImagesVisible:boolean;
	public translationResult: string = '';
	public activeTab: string = 'media';
	
	// @ngInject
	constructor(
		private bookService		: BookService,
		private observerService	: ObserverService,
		private ModalService,
		public listingModalService: ListingModalService
	) {}
	
	public $onInit = () => {
		this.observerService.attach( this.openPageAssets, 'openPageAsset' );
		this.observerService.attach(this.showTranslation, 'showTranslation');
		this.observerService.attach(this.onTranslationDisabled, 'translationDisabled');
	}
	
	
	public onTranslationDisabled = () => {

    this.translationResult = null;

    if (this.hasMedia()) {
        this.activeTab = 'media';
        return;
    }

    if (this.isImagesVisible) {
        this.togglePanel();
    }
};
	
public showTranslation = (text:any) => {

    if (!text) return;

    this.translationResult = text;

    // make translation tab active
    this.activeTab = 'translation';

    // open sidebar if closed
    if (!this.isImagesVisible) {
        this.togglePanel();
    }
}

public hasMedia = () => {
    return Object.keys(this.pageImages || {}).length > 0 ||
           Object.keys(this.pageVideos || {}).length > 0;
}
	
	
	/** method attached with observer service, can be used to open book page asset 
	 * */
	 
	 
	 public openPageAssets = (data:any) => {

    let hasMedia, translationEnabled;

    if (typeof data === 'boolean') {
        hasMedia = data;
        translationEnabled = false;
    } else {
        hasMedia = data?.hasMedia;
        translationEnabled = data?.translationEnabled;
    }

    if (hasMedia || translationEnabled) {
        if (!this.isImagesVisible) this.togglePanel();
        return;
    }

    if (this.isImagesVisible) this.togglePanel();
};
	 
	 
	 

	
	public togglePanel = (): void => {
		this.isImagesVisible = !this.isImagesVisible;
	}
	
	public onLaunchSlideShow = () => {
		if( Object.keys(this.pageImages).length == 0 ) {
			return;
		}
	    this.launchSlideshowModal(  this.pageImages );
	}
	
	public onViewImage = ( image:any ) => {
		this.launchSlideshowModal(  [image], true );
	}
	
	public onViewVideo = ( video:any ) => {
		if(video.s3LinkUrl){
			this.listingModalService.launchVideoPlayerModal( video.s3LinkUrl );
		} else {
			this.listingModalService.launchVideoPlayerModal( video.linkUrl );	
		}
	}
	
	private launchSlideshowModal = ( images: Array<any>, hideFooter: boolean = false, goTo = 0) => {
		let bindings:any = {
			images: images,
			goTo : goTo,
			hideFooter: hideFooter
		}
		
		this.ModalService.showModal({
			component: 'imageGallerySlideshowModal',
			bodyClass: 'angular-modal-service-active',
			bindings: bindings,
			preClose: this.ModalService.closeModals,
		})
		.then( (modal: Modal) =>  modal.close.then( (result) => {}) );
	}
}

class BookPageAssets {
	public restrict: string = 'EA';
	public scope: boolean = true;

	public bindToController: any = {
		pageImages: '<',
		pageVideos: '<',
		isImagesVisible: '='
	};

	public controller = BookPageAssetsController;
	public controllerAs = 'bookPageAssets';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/book-page-assets.html';

	public static Factory() {
		return () => new this();
	}
}

export { BookPageAssets };